import { User } from './user';
import { Permission } from './permission';

export class PermissionUser {
  permission_uuid!: string;
  permission_level!: number;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  permission?: Permission;

  static getSortColumns() {
    return ['permission_level'];
  }

  constructor(data: any) {
    this.permission_uuid = data.permission_uuid;
    this.permission_level = data.permission_level;
    this.status = data.status;
    this.user_uuid = data.user_uuid;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.permission) {
      this.permission = new Permission(data.permission);
    }
  }
}
